import { GaleriaBig, GaleriaIcons } from "@/galeria/Galeria";
import { useAppContext } from "@/state/appContext";
import type { Pedido } from "@/state/types";
import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { bindProps } from "@/helpers/helpers";
import { z } from "zod";
import { PedidoIcons } from "@/pedidos/PedidoIcons";
import { PedidoResumen } from "@/pedidos/PedidoResumen";

export const Route = createFileRoute("/_app/pedido")({
  component: PedidoPage,
  validateSearch: z.object({
    id: z.number(),
  }),
});

function PedidoPage() {
  const { id } = Route.useSearch();
  const status = useAppContext(true);
  const pedido = status.state.usuario.pedidos[id];

  const icons = pedido.pagado
    ? GaleriaIcons
    : bindProps(PedidoIcons, {
        pedido: pedido.id,
      });

  return (
    <GaleriaBig
      fotos={pedido.fotos.filter((f) => f.cantidad)}
      icons={icons}
      container={({ children }: { children: ReactNode }) => (
        <PedidoContainer pedido={pedido}>{children}</PedidoContainer>
      )}
    ></GaleriaBig>
  );
}

function PedidoContainer({
  pedido,
  children,
}: {
  pedido: Pedido;
  children: ReactNode;
}) {
  return (
    <>
      <div className="container">
        <div className="row">
          <div className={pedido.pagado ? "col-md-12" : "col-md-8 col-lg-9"}>
            {children}
          </div>
          {pedido.pagado || (
            <div className="col-md-4 col-lg-3">
              <div className="detalles_carrito">
                <PedidoResumen pedido={pedido} />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
